import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute} from "@angular/router";
import {getMyServiceFeedbackComplaints} from "../../../../store/entities/feedback/feedback.actions";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/reducers";
import {Observable} from "rxjs";
import {FeedbackComplaint} from "../../../../store/entities/feedback/feedback.model";
import {
  selectModifiedFeedbacks,
  selectModifiedFeedbacksByfeedBackUuid
} from "../../../../store/entities/feedback/feedback.selectors";
import {SettingsService} from "../../../../services/settings.service";
import {AttachmentViewComponent} from "../attachment-view/attachment-view.component";
import {TrackComplaintsService} from "../../../../services/track-complaint.service";

@Component({
  selector: 'app-feedback-follow-up',
  templateUrl: './feedback-follow-up.component.html',
  styleUrl: './feedback-follow-up.component.scss'
})
export class FeedbackFollowUpComponent implements OnInit{

  form: FormGroup;

  feedbackUniqueId: string
  myFeedbacks: Observable<FeedbackComplaint>;

  alert: string
  complaintTracking: any

  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private settingsService: SettingsService,
    private trackingService: TrackComplaintsService
  ) {
  }


  ngOnInit() {
    this.feedbackUniqueId = this.activatedRoute.snapshot.paramMap.get("uniqueId");

    this.form = this.fb.group({
      followUpId: [null, [Validators.required]],
    })

    this.store.dispatch(getMyServiceFeedbackComplaints({
      filtering: {
        pageNumber: 1,
        uniqueId: this.feedbackUniqueId
      }
    }))

    this.myFeedbacks = this.store.select(selectModifiedFeedbacksByfeedBackUuid(this.feedbackUniqueId))
    this.myFeedbacks.subscribe((item) => {
      if (item?.trackNumber) {
        this.trackingService.trackComplaint(item.trackNumber).subscribe({
          next: (data) => {
            console.log('Tracking Result:', data);
            this.complaintTracking = data
          },
          error: (err) => {
            console.error('Error tracking complaint:', err);
          },
        });
      }
    })
  }

  copyToClipboard(text): void {
    if (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.alert = 'Track number copied to clipboard!'

        setTimeout(() => {
          this.alert = '';
        }, 2000);
      }).catch(err => {
        this.alert = `Failed to copy text: ${err}`
        console.error('Failed to copy text: ', err);

        setTimeout(() => {
          this.alert = '';
        }, 2000);
      });
    }
  }

  openAttachment(filePath){
    this.settingsService.openDialogModal({
      component: AttachmentViewComponent,
      data: {
        filePath:filePath
      }
    })
  }
}
